import { render, staticRenderFns } from "./DiagnostFactors.vue?vue&type=template&id=578b2246&scoped=true&"
import script from "./DiagnostFactors.vue?vue&type=script&lang=js&"
export * from "./DiagnostFactors.vue?vue&type=script&lang=js&"
import style0 from "./DiagnostFactors.vue?vue&type=style&index=0&id=578b2246&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578b2246",
  null
  
)

export default component.exports